import { useQuery } from '@tanstack/react-query';
import { apiGet, qk } from './_client';

/** GET /api/films/{id}/scenes — legacy un-paginated list (scenes + shot counts). */
export function useFilmScenes(filmId, options = {}) {
  const { enabled, ...rest } = options;
  return useQuery({
    queryKey: qk.filmScenes(filmId),
    queryFn: ({ signal }) => apiGet(`/films/${filmId}/scenes`, signal),
    enabled: !!filmId && (enabled ?? true),
    ...rest,
  });
}
